import { FC } from 'react';
import { ReactComponent as FailureIcon } from 'assets/icons/Failure.svg';

const ErrorFallBackComponent: FC = () => {
  return (
    <div className='mx-auto flex min-h-screen w-full max-w-md flex-col items-center justify-center space-y-6 p-4'>
      <FailureIcon className='mx-auto h-32 w-auto' />
      <h2 className='text-center text-base font-bold text-gray-500'>
        Something went wrong,{' '}
        <span className='whitespace-nowrap'>please try again later.</span>
      </h2>
    </div>
  );
};

export default ErrorFallBackComponent;
